import ApiService from "./api.service";
import axios from "axios";

// Constant
const baseUrl = 'notification/'

const NotificationService = {
		/**
	 * Retrieve notifications from server
	 * @param {Params} params 
	 * @returns {Response} response
	 */
		getAllNotification(params) {
			return ApiService.get(baseUrl, params);
	},
	
	/**
	 * Update notification
	 * @param {Params} params
	 * @returns {Response} response 
	 */
	updateNotification(params) { 
		return ApiService.put(baseUrl, params);
	}

};

export default NotificationService;
